import * as studentTypes from "Store/students/constants";
import * as studentLessonsTypes from "Store/students/studentsLessons/constants";
import * as studentWorksheetsTypes from "Store/students/studentsWorksheets/constants";
import * as studentTestsTypes from "Store/students/studentsTests/constants";

const initialState: IStudentsReducer = {
  ////Pre-Made Worksheets Reducers///////
  activeLesson: null,
  activeShowPage: "",
  activeStudent: null,
  activeStudentSummary: null,
  activeStudentTest: null,
  activeTestScores: null,
  activeWorksheet: null,
  calendarRows: [],
  categories: [],
  isCoursesLinkActive: false,
  isScoreReportReady: false,
  lessonList: [],
  queryOptions: { archived: false },
  reportPreview: null,
  returnToCalendar: false,
  scoredTests: [],
  studentActionSpinner: false,
  studentLessonList: [],
  studentSessions: [],
  studentTestReportPdf: null,
  studentTestSections: [],
  studentTestReportLink: null,
  studentTestReportData: null,
  studentTests: [],
  studentWorksheetList: [],
  students: [],
  studentsStatistics: null,
  testSectionProblems: [],
  tests: []
  // studentLessonsPagination: PAGINATION_INIT.studentLessons
};

const handleActions = (state: IStudentsReducer, action) => {
  switch (action.type) {
    case studentTypes.SET_STUDENTS:
      return {
        students: action.payload
      };
    case studentTestsTypes.SET_ACTIVE_TEST_SCORES:
      return {
        activeTestScores: action.payload
      };
    case studentTestsTypes.SET_ESSAY_SCORE:
      return {
        activeTestScores: {
          ...state.activeTestScores,
          essay: action.payload
        }
      };
    case studentTestsTypes.SET_STUDENT_TESTS:
      return {
        studentTests: action.payload
      };
    case studentTestsTypes.SET_STUDENT_TEST_SECTIONS:
      return {
        studentTestSections: [...action.payload]
      };
    case studentTestsTypes.SET_STUDENT_TEST_REPORT_LINK:
      return {
        studentTestReportLink: action.payload
      };
    case studentTestsTypes.SET_STUDENT_TEST_REPORT_DATA:
      return {
        studentTestReportData: action.payload
      };

    case studentLessonsTypes.SET_STUDENT_ACTIVE_LESSON:
      return {
        activeLesson: { ...action.payload }
      };

    case studentTypes.SET_ACTIVE_STUDENT:
      return { activeStudent: { ...action.payload } };

    case studentTestsTypes.SET_STUDENT_TEST_PROBLEM_FLAG_STATUS:
      const newSections = state.studentTestSections.map((section) => {
        if (section.test_section_id === action.payload.test_section_id) {
          const updatedProblems = section.problems.map((problem) => {
            if (problem.id === action.payload.test_problem_id) {
              return { ...problem, flag: action.payload.flag };
            }
            return problem;
          });
          return {
            ...section,
            problems: updatedProblems
          };
        }
        return section;
      });
      return {
        studentTestSections: [...newSections]
      };

    case studentWorksheetsTypes.SET_STUDENT_WORKSHEET_PROBLEM_FLAG:
      const activeWorksheetUpdate = state.activeWorksheet;
      let previousProblemStatus;

      const problemIndex = activeWorksheetUpdate.problems.findIndex(
        (problem) => problem.id === action.payload.problem_id
      );
      const problem = activeWorksheetUpdate.problems[problemIndex];
      if (problem) {
        previousProblemStatus = problem.flag_status;
        activeWorksheetUpdate.problems[problemIndex] = {
          ...problem,
          flag_status: action.payload.flag_status
        };

        switch (previousProblemStatus) {
          case "UN_FLAGGED":
            activeWorksheetUpdate.problem_flag_count = activeWorksheetUpdate.problem_flag_count + 1;
            break;
          case "FLAGGED":
            activeWorksheetUpdate.problem_flag_count =
              activeWorksheetUpdate.problem_flag_count - 1 === 0
                ? 0
                : activeWorksheetUpdate.problem_flag_count - 1;
            activeWorksheetUpdate.reviewed_problems = activeWorksheetUpdate.reviewed_problems + 1;
            break;
          case "REVIEWED":
            activeWorksheetUpdate.reviewed_problems =
              activeWorksheetUpdate.reviewed_problems - 1 === 0
                ? 0
                : activeWorksheetUpdate.reviewed_problems - 1;
            break;
        }
      }

      return {
        activeWorksheet: { ...activeWorksheetUpdate }
      };

    case studentLessonsTypes.SET_STUDENT_LESSON_PROBLEM_FLAG:
      const activeLesson: Lesson = state.activeLesson as Lesson;
      let previousStatus;
      Object.keys(activeLesson.problems).forEach((section) => {
        const problemIndex = activeLesson.problems[section].findIndex((problem) => {
          return problem?.problem?.id === action?.payload.problem_id;
        });
        const problem = activeLesson.problems[section][problemIndex];
        if (problem) {
          previousStatus = problem.flag_status;
          activeLesson.problems[section][problemIndex] = {
            ...problem,
            flag_status: action.payload.flag_status
          };

          switch (previousStatus) {
            case "UN_FLAGGED":
              activeLesson.problem_flag_count = activeLesson.problem_flag_count + 1;
              break;
            case "FLAGGED":
              activeLesson.problem_flag_count =
                activeLesson.problem_flag_count - 1 === 0 ? 0 : activeLesson.problem_flag_count - 1;
              activeLesson.reviewed_problems = activeLesson.reviewed_problems + 1;
              break;
            case "REVIEWED":
              activeLesson.reviewed_problems =
                activeLesson.reviewed_problems - 1 === 0 ? 0 : activeLesson.reviewed_problems - 1;
              break;
          }
        }
      });
      return {
        activeLesson: { ...activeLesson }
      };

    case studentTestsTypes.SET_STUDENT_TEST_FLAG_COUNT:
      const problem_flag_count =
        state.activeStudentTest.problem_flag_count + action.payload.problem_flag_count;
      const reviewed_problems =
        state.activeStudentTest.reviewed_problems + action.payload.reviewed_problems;
      return {
        activeStudentTest: {
          ...state.activeStudentTest,
          problem_flag_count: problem_flag_count < 0 ? 0 : problem_flag_count,
          reviewed_problems: reviewed_problems < 0 ? 0 : reviewed_problems
        }
      };

    case studentTypes.SET_STUDENT_SUMMARY:
      return {
        activeStudentSummary: action.payload
      };

    case studentTypes.SET_STUDENT_SESSIONS:
      return {
        studentSessions: action.payload
      };

    case studentTestsTypes.SET_ACTIVE_STUDENT_TEST:
      return { activeStudentTest: action.payload };

    case studentTypes.HANDLE_REMOVE_INSTRUCTOR_FROM_STUDENT:
      if (action.source && action.source === "accountPage") {
        return {
          activeStudent: {
            ...state.activeStudent,
            instructors: state.activeStudent.instructors.filter(
              (instructor) => instructor.id !== action.payload.instructor_id
            )
          }
        };
      }
      return {
        students: state.students.map((student) => {
          if (student.id === action.payload.student_id) {
            return {
              ...student,
              instructors: student.instructors.filter(
                (instructor) => instructor.id !== action.payload.instructor_id
              )
            };
          }
          return student;
        })
      };

    case studentWorksheetsTypes.SET_ACTIVE_WORKSHEET:
      return {
        activeWorksheet: { ...action.payload }
      };

    case studentLessonsTypes.SET_STUDENT_LESSONS:
      return {
        studentLessonList: [...action.payload]
      };

    case studentTypes.HANDLE_UPDATE_STUDENT_REPORT_LOCALLY:
      const newStudentsArray = state.students;
      let _index;
      const _student = newStudentsArray.find((student, index) => {
        if (student.id === action.payload.studentId) {
          _index = index;
          return student;
        }
      });
      newStudentsArray[_index] = {
        ..._student,
        report: action.payload.report
      };
      return {
        students: [...newStudentsArray]
      };
    case studentTypes.SET_STUDENT_REPORT_PREVIEW:
      return {
        reportPreview: action.payload
      };
    case studentTypes.SET_STUDENT_ACTION_SPINNER:
      return {
        studentActionSpinner: action.payload
      };
    case studentTypes.SET_STUDENTS_STATISTICS:
      return {
        studentsStatistics: action.payload
      };
    case studentTestsTypes.SET_STUDENT_SCORED_TESTS:
      return {
        scoredTests: action.payload
      };

    case studentTestsTypes.SET_STUDENT_TEST_PREVIEW_PDF:
      return {
        studentTestReportPdf: action.payload
      };
    case studentTestsTypes.SET_TRIBYTE_TEST_SECTION_URL:
      const { url, sectionId } = action.payload;
      const sections = state.activeStudentTest.sections.map((section) =>
        section.id === sectionId ? { ...section, url } : section
      );
      return { activeStudentTest: { ...state.activeStudentTest, sections: sections } };
    case studentWorksheetsTypes.SET_STUDENT_WORKSHEETS:
      return {
        studentWorksheetList: [...action.payload]
      };
    default:
      return {};
  }
};

const studentReducer = (state = initialState, action) => ({
  ...state,
  ...handleActions(state, action)
});

export default studentReducer;
